import { Controller } from "@hotwired/stimulus";
import { createServer } from "@medware/bridge";

export default class extends Controller {
  static values = {
    token: String,
    src: String
  };

  tokenValue!: string;
  srcValue!: string;

  server: ReturnType<typeof createServer> | undefined;

  connect() {
    const $iframeElement = document.createElement("iframe");

    $iframeElement.src = this.srcValue;
    $iframeElement.classList.add("w-100", "h-100", "border-0");

    // Set up the postMessage handler first
    this.server = createServer({
      onRequest: this.handleRequest.bind(this),
      trustedSources: (source) => {
        return source === $iframeElement.contentWindow;
      },
      debug: {
        name: "PM Backend",
        enabled: true
      }
    });

    // Inject the iframe when we are ready to listen
    this.element.appendChild($iframeElement);
  }

  disconnect() {
    this.server?.dispose();
  }

  handleRequest(request: { methodName: string }) {
    const { methodName } = request;

    switch (methodName) {
      case "ExecutionCompleted":
        return this.handleExecutionCompleted();

      case "RequestAccessToken":
        return this.handleRequestAccessToken();

      default:
        throw new Error(`Method not implemented: ${methodName}`);
    }
  }

  handleExecutionCompleted() {
    return {
      methodName: "ExecutionCompletedReply",
      succes: true
    };
  }

  handleRequestAccessToken() {
    if (!this.tokenValue) {
      return {
        methodName: "AccessTokenReply",
        succes: false,
        errorMessage: "No token"
      };
    }

    return {
      methodName: "AccessTokenReply",
      succes: true,
      result: this.tokenValue
    };
  }
}
